import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  card: {
    minWidth: 275,
    height: 200,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)'
  },
  title: {
    fontSize: 21,
    fontWeight: 'bold'
  },
  icons: {
    display: 'flex',
    padding: 8,
    alignItems: 'flex-end',
    flexGrow: 1,
    justifyContent: 'flex-end'
  },
  actionButtons: {
    display: 'flex',
    padding: 8,
    flexGrow: 1,
    justifyContent: 'flex-start'
  },
  icon: { margin: '6px 6px' },
  container: {
    marginTop: 20
  },
  newTranscriptContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    flexDirection: 'column'
  },
  addIcon: { marginBottom: 10 },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  cardActionArea: {
    '&.actionsDisabled': {
      cursor: 'default !important'
    },
    flexGrow: 1
  }
}));
